// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"474":"1b8bdb13","638":"4a92424d","918":"b9f4c4d3","945":"f3ae5607","994":"f4628903"}[chunkId] + ".chunk.js";
};